import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "../../../components/DatePicker/DatePicker";
import Filter from "../../../components/Filter/Filter";
import { Icon } from "../../../components/Icon";
import Pagination from "../../../components/Pagination/Pagination";
import getDate from "../../../helpers/getDate";
import { createTransaction, getCurrency, getReferalInformation, getTransactionsList, returnTransaction } from "../../../redux/actions/transaction";
import Select from "../../../components/Select/Select";
import Hint from "../../../components/Hint/Hint";
import Sort from "../../../components/Sort/Sort";
import { setMessage } from "../../../redux/actions/auth";

const sortOptions = [
    { id: "createdAt", value: "За датою створення" },
];

const ProfileWalletPage=()=>{
    const { t } = useTranslation();
    const dispatch =useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const user = useSelector((state) => state.currentUser.user);
    const transaction = useSelector((state) => state.transaction);
    const list = useSelector((state) => state.list);
    const hint = useSelector((state) => state.hints);
    const token = useSelector((state) => state.auth.user.accessToken);
    const system = useSelector((state) => state.system);
    const [filterApplying, setFilterApplying] = useState(false);
    
    
    const [pageCur,setPageCur]=useState(1);
    const [sort,setSort]=useState('desc');
    const [ready, setReady] = useState(false);
    const [curReady, setCurReady] = useState(false);
    const [referalData, setReferalData] = useState({});
    const [currency, setCurrency] = useState({});
    
    const [checkReturn, setCheckReturn] = useState('f');
    const [checkAdd, setCheckAdd] = useState('f');
    
    const [sortValue,setSortValue]=useState('createdAt');
    const [form, setForm] = useState(false);
    const [errors, setErrors] = useState({});
    const [needGet, setNeedGet] = useState(false);
    const [currencyValue, setCurrencyValue] = useState({}); 

    const [filter, setFilter] = useState(() => {
        const savedFilter = localStorage.getItem("profileWalletPage");
        return savedFilter ? JSON.parse(savedFilter) : {};
    });

    const changeHandler = (e) => {
        const { id, value } = e.target;
        let updatedFilter = { ...filter };

        if (e.target.tagName === 'SELECT' && e.target.accessKey) {
            updatedFilter[e.target.accessKey] = value;
        }
        else if (id === "dateFrom" || id === "dateTo") {
            updatedFilter[id] = getDate(value, "yyyy/mm/dd", "-");
            setNeedGet(true);
        } 
        else if (id === "all" && value.length<3 && value.length>0) {
           
        }
        else if (value.length<1) {
            delete updatedFilter[id];
        } 
        else {
            updatedFilter[id] = value;
        }
        setFilter(updatedFilter);
    };

    const validationHandler = (e) => {
        const { id, value } = e.target;

        switch (id) {
            case 'cardNumber':
                if (value.replace(' ', '').length < 16) {
                    setErrors({...errors, [id]: 'Номер карти має містити 16 символів' })
                } else {
                    setErrors({...errors, [id]: '' })
                }
                break;
            case 'iban':
                if (value.replace(' ', '').length < 29) {
                    setErrors({...errors, [id]: 'Номер рахунку має містити 29 символів' })
                } else {
                    setErrors({...errors, [id]: '' })
                }
                break;   
            case 'cardHolder':
                if (value.replace(' ', '').length === 0) {
                    setErrors({...errors, [id]: 'Необхідне поле' })
                } else {
                    setErrors({...errors, [id]: '' })
                }
                break;
            case 'taxId':
                if (value.replace(' ', '').length > 10) {
                    setErrors({...errors, [id]: 'РНОКПП/ЄДРПОУ має містити 10 символів' })
                } else {
                    setErrors({...errors, [id]: '' })
                }
                break;
            default:
                setErrors({ ...errors, [id]: '' });
        }
    };

    const changeHandlerForm = (e) => {
        const { id, value } = e.target;
        let updatedFilter = { ...form };

        if (e.target.tagName === 'SELECT' && e.target.accessKey) {
            updatedFilter[e.target.accessKey] = value;
        }
        else 
        if (id === "dataBirthdayFrom" || id === "dataBirthdayTo") {
            updatedFilter[id] = getDate(value, "yyyy/mm/dd", "-");
        }
        else if (value.length<1) {
            delete updatedFilter[id];
        } 
        else {
            updatedFilter[id] = value;
        }
        setForm(updatedFilter);
    };

    const initFunc = (page = 1) => {
        let data = {};
        data.limit = 10;
        data.offset = (page - 1) * data.limit;
        data.filter = filter;
        data.sort={};
        data.sort[sortValue]=sort;

        dispatch(getTransactionsList(data)).then(() => {
            setReady(true);
        });
    };
   

    const addClick = () => {
        if (+form.addMoney < +system?.SettingsPayment?.fiatAdd) {
            dispatch(setMessage({
                message: 'Мінімальна кількість токенів: '+system?.SettingsPayment?.fiatAdd,
                type: 'error',
            }));
            return;
        }
        const myData = {
            quantity:form.addMoney,
            transactionStatus: '609ee129-b2a7-486e-966a-78a23221d301',
            currencyType: 1,
            frozen: 0,
            type: 1,
            paymentSystem: 'coocooPay',
            paymentOrg: form.paymentOrg
        };
        dispatch(createTransaction(myData)).then(res => {
            window.open(res.acquiringUrl+'?token='+token,'_blank');
            }).catch(e=>{

        });
        // dispatch(setMessage({
        //     message: 'Наразі функція не доступна',
        //     type: 'error',
        // }));
        // return;
    };

    const addClickCrypto =()=>{
        if (+form.addMoney < +system?.SettingsPayment?.cryptoAdd) {
            dispatch(setMessage({
                message: 'Мінімальна кількість токенів: '+system?.SettingsPayment?.cryptoAdd,
                type: 'error',
            }));
            return;
        }
        const myData = {
            quantity:  form.addMoney,
            transactionStatus: '609ee129-b2a7-486e-966a-78a23221d301',
            currencyType: 0,
            frozen: 0,
            type: 1,
            paymentSystem: 'whitePay'
        };
        dispatch(createTransaction(myData)).then(res => {
            window.open(res.acquiringUrl,'_blank', 'noopener');
            }).catch(e=>{
        });

    }
    
    const calculateCryptoPayment = (amount) => {
        if (amount <= 55.56) {
            return amount + 0.5;
        }

        return amount + amount * 0.009;
    };

   
    const resetFilter=()=>{
        setFilter({});
        setFilterApplying(true);
    }

    const applyFilter = () => {
        setFilterApplying(true);
    }

    const onSortValueChange= (sortOption) => {
        setSortValue(sortOption.id);
        setSort(sortOption.sort);
        localStorage.setItem('profileWalletPageSort', JSON.stringify({id: sortOption.id, sort: sortOption.sort}));
    }
    const  getReferalInfo =()=>{
        dispatch(getReferalInformation({id:user.id})).then(res=>{
            setReferalData(res);
        })
    }

    const returnClick=()=>{
        if ( checkReturn=='c' && form.amount < system?.SettingsPayment?.cryptoWithdraw) {
            dispatch(setMessage({
                message: `Нижня межа на виведення токенів: ${system?.SettingsPayment?.cryptoWithdraw}`,
                type: 'error',
            }))
            return;
        }
        if (checkReturn=='f' &&  form.amount < system?.SettingsPayment?.fiatWithdraw) {
            dispatch(setMessage({
                message: `Нижня межа на виведення токенів: ${system?.SettingsPayment?.fiatWithdraw}`,
                type: 'error',
            }))
            return;
        }
        if( checkReturn=='c' && +form.amount > +user?.userMoney?.balanceCoin){
            dispatch(setMessage({
                message: `Неможливо вивести більше коштів, ніж доступно`,
                type: 'error',
            }))
            return;
        }
        if( checkReturn=='f' && +form.amount > +user?.userMoney?.balanceFiat){
            dispatch(setMessage({
                message: `Неможливо вивести більше коштів, ніж доступно`,
                type: 'error',
            }))
            return;
        }

        let data={
            'coinType':checkReturn=='c'?'coin':'fiat',
            'amount':form.amount
        }

        if (checkReturn=='f'){
            data.address=form.cardNumber;
            data.exchangeCurrency='USD';
            const cashoutTypeParts = form.cashoutType.split('/');
            data.cashoutType=cashoutTypeParts[0];
            data.paymentSystem = cashoutTypeParts.length > 1 ? cashoutTypeParts[1] : 'p2p'; // fixme default 'p2p' for non card type!
        }
        if(checkReturn=='c' && form.cashoutType === 'wallet'){
            data.cashoutType=form.cashoutType;
            data.address=form.wallet;
            data.exchangeCurrency='USDT';
        }
        if(checkReturn=='c' && form.cashoutType === 'iban'){
            data.cashoutType=form.cashoutType;
            data.address=form.ibanNumber;
            data.exchangeCurrency='USD';
        }
        dispatch(returnTransaction(data)).then(res=>{
            dispatch(setMessage({
                message: `Транзакція створена успішно. Очікуйте на зарахування коштів від 10 хв до 4 годин`,
                 type: 'success',
            }))            
        })
    }

    useEffect(() => {
        if (!ready) {
            if(user?.isReferal){
                getReferalInfo();
            }
            initFunc();
            const intervalId = setInterval(initFunc, 100);
            return () => clearInterval(intervalId);
        }
    }, [ready,user]);


    useEffect(() => {
        if (ready&& needGet) {
            setNeedGet(false)
            initFunc();
        }
    }, [needGet]);

    useEffect(() => {
        initFunc()
    }, [sort])

    useEffect(() => {
        if (filterApplying) {
            initFunc();
            setFilterApplying(false);
        }
    }, [filterApplying])
    useEffect(() => {
        if (!curReady && !ready) {
          const timer = setTimeout(() => {
            if (!curReady) {
              dispatch(getCurrency()).then(res => {
                setCurReady(true);
                setCurrency(res);
                console.log(res);
              });
            }
          }, 100);
      
          return () => clearTimeout(timer);
        }
      }, []); 

    return(<>
        <div className="profileSectionBlock prFlexRow walletBalanceBlock">
            <div>
                 <div className="userEditLeft">
                    <h2>{t('current_money')}
                        <div className="infoHelp">
                            <Hint align='left' item={hint[3]}/>
                        </div>
                    </h2>
                    <div className="infoText">
                        {t('profile_wallet_current_info_text')}
                    </div>
                    <div className="prflexColumn" style={{ width: '100%' }}>
                        <div className="profileSectionBlockMoneyInfo">
                            <h3>
                                <Icon type='fTocken'></Icon> {t('fiat')}
                            </h3>
                            <div className="token-info ">
                            {/* <div className="token-info moneyInfoBlock"> */}
                                <div className="token-row">
                                    <span className="token-label">Вільні</span>
                                    <span className="token-value green">{user?.userMoney?.balanceFiat}</span>
                                    <span className="token-icon green">F</span>
                                </div>
                                <div className="token-row">
                                    <span className="token-label">Зарезервовані</span>
                                    <span className="token-value orange">{user?.userMoney?.balanceFiatFrozen}</span>
                                    <span className="token-icon orange">F</span>
                                </div>
                                                                
                            </div>
                        </div>
                        <div className="profileSectionBlockMoneyInfo">
                            <h3>
                                <Icon type='cTocken'></Icon> {t('crypto')}
                            </h3>
                            <div className="token-info">
                                <div className="token-row">
                                    <span className="token-label">Вільні</span>
                                    <span className="token-value green">{user?.userMoney?.balanceCoin}</span>
                                    <span className="token-icon green">C</span>
                                </div>
                                <div className="token-row">
                                    <span className="token-label">Зарезервовані</span>
                                    <span className="token-value orange">{user?.userMoney?.balanceCoinFrozen}</span>
                                    <span className="token-icon orange">C</span>
                                </div>
                                                                
                            </div>
                        </div>
                    </div>
                </div>
                {user?.isReferal && <div className="userEditLeft">
                     <h2>{t('referal_program')}
                    <div className="infoHelp">
                        <Hint align='left' item={hint[93]}/>
                    </div>
                </h2>
                    <div className="infoText" style={{display:'block'}}>
                            {t('referal_program_info_text')} 
                            <a style={{cursor:'pointer'}} href="https://rivalsroom.com/referral">https://rivalsroom.com/referral</a>
                    </div>
                    <div className="prflexColumn" style={{ width: '100%' }}>
                        <div className="profileSectionBlockMoneyInfo">
                            <h3>
                                {t('referal_link')} 
                            </h3>
                            <div className="infoText">
                               https://my.rivalsroom.com/ref/{user.nickname}                                 
                            </div>
                        </div>
                       <div className="profileSectionBlockMoneyInfo">
                            <h3>
                                {t('referal_code')} 
                            </h3>
                            <div className="infoText">
                              {user.nickname}                    
                            </div>
                        </div>
                        <div className="profileSectionBlockMoneyInfo">
                            <h3>
                                {t('referal_amount')} 
                            </h3>
                            <div className="infoText">
                              {referalData.amoutUser}                                
                            </div>
                        </div>
                         <div className="profileSectionBlockMoneyInfo">
                            <h3>
                                {t('referal_income')} 
                            </h3>
                            <div className="infoText" style={{display:'block'}}>
                                 <div className="token-row">
                                    <Icon type='fTocken'></Icon>
                                    <span className="token-value green">{referalData.totalFiat}   </span>
                                </div>
                                 <div className="token-row">
                                    <Icon type='cTocken'></Icon>
                                    <span className="token-value green">{referalData.totalCoins}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
            {!system.SettingsPromo.isPromo && <div className="userEditLeft balanceOperations">
                <h2>{t('add_money')}
                    <div className="infoHelp">
                        <Hint align='left' item={hint[4]}/>
                    </div>
                </h2>
                <div className="infoText">
                   {t("current_currency")}
                </div>
                <div className="infoText">
                    1$ = 1 <Icon type='fTocken'></Icon>  
                    = 1 <Icon type='cTocken'></Icon>  = {currency.rateSell}₴
                </div>
                <br />
                { hint[70]?.description?.length>0 && <div className="infoText"
                    dangerouslySetInnerHTML={{__html: hint[70].description}}
                >
                </div>}
                <br />
                <div className="textWithInfoHelp">
                    {t("choose_tocken_type")}
                    <div className="infoHelp">
                        <Hint align='left' item={hint[5]}/>
                    </div>
                </div>
                <div className="radioSelect">
                    <div  onClick={()=>setCheckAdd('f')} className={checkAdd=='f'?"radioSelectItem checked":"radioSelectItem"}></div>
                    <Icon onClick={()=>setCheckAdd('f')} type='fTocken'></Icon>
                    <div style={{marginLeft:'37px'}} onClick={()=>setCheckAdd('c')}  className={checkAdd=='c'?"radioSelectItem checked":"radioSelectItem"}></div>
                    <Icon onClick={()=>setCheckAdd('c')} type='cTocken'></Icon>
                </div>

                <div className="textWithInfoHelp">
                    {t("tocken_buy")} 
                    <div className="infoHelp">
                        <Hint align='left' item={hint[6]}/>
                    </div>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                    <input
                        className="prInputInput"
                        id='addMoney'
                        type="number"
                        onChange={changeHandlerForm}
                        value={form.addMoney || ''}
                    />

                     {form.addMoney && form.addMoney>0 && `- буде списано ${checkAdd=='c'? calculateCryptoPayment(Number(form.addMoney)).toFixed(2)+'$':form.paymentOrg=='p2p'?(+form.addMoney/((100-7)/100)*currency.rateSell).toFixed(2)+'₴':(+form.addMoney/((100-system.SettingsPayment.feeFiat)/100)).toFixed(2)+'$'}`}
                    </div>
                {checkAdd=='f'&&<><div className="textWithInfoHelp">
                    {t("choose_payment_system")} 
                    <div className="infoHelp">
                        <Hint align='left' item={hint[7]}/>
                    </div>
                </div>
                <div className="prInput">
                    <Select
                        id="paymentOrg"
                        value={form.paymentOrg || ''}
                        onChange={changeHandlerForm}
                        placeholder="Платіжна система"
                        options={[
                            {id: 'p2p', title: 'CooCooPay p2p (UAH)'},
                            {id: 'qvazi', title: 'CooCooPay qvazi (USD)'},
                        ]}
                    />
                </div></>}
                <div className="dFlex jCC">
                    <button className="prButton prButtonMain" onClick={checkAdd=='c'?addClickCrypto:addClick}>{t('add')}</button>
                </div>
                

            </div>}
            {!system.SettingsPromo.isPromo &&<div className="userEditLeft balanceOperations">
                <h2>{t('return_money')}
                    <div className="infoHelp">
                        <Hint align='left' item={hint[8]}/>
                    </div>
                </h2>
                <div className="infoText">
                   {t("current_currency")}
                </div>
                <div className="infoText">
                    1$ = 1 <Icon type='fTocken'></Icon>  
                    = 1 <Icon type='cTocken'></Icon> = {currency.rateSell}₴
                </div>
                <br />
                {hint[71]?.description?.length>0 && <div className="infoText"
                    dangerouslySetInnerHTML={{__html: hint[71].description}}
                >
                </div>}
                <br />
                <div className="textWithInfoHelp">
                    {t("choose_tocken_type")} 
                    <div className="infoHelp">
                        <Hint align='left' item={hint[9]}/>
                    </div>

                </div>
                <div className="radioSelect">
                    <div  onClick={()=>setCheckReturn('f')} className={checkReturn=='f'?"radioSelectItem checked":"radioSelectItem"}></div>
                    <Icon onClick={()=>setCheckReturn('f')} type='fTocken'></Icon>
                    <div style={{marginLeft:'37px'}} onClick={()=>setCheckReturn('c')}  className={checkReturn=='c'?"radioSelectItem checked":"radioSelectItem"}></div>
                    <Icon onClick={()=>setCheckReturn('c')} type='cTocken'></Icon>
                </div>

                <div className="textWithInfoHelp">
                    {t("tocken_return")} 
                    <div className="infoHelp">
                        <Hint align='left' item={hint[10]}/>
                    </div>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                    <input
                        id={'amount'}
                        type="number"
                        className="prInputInput"
                        min={system?.SettingsWallet?.lowerLimitToken}
                        onChange={changeHandlerForm}
                        value={form.amount || ''}
                    />
                    {form.amount && form.amount>0 && `- буде зараховано ${checkReturn=='c'?form.amount:form.cashoutType=='card/p2p'?(+form.amount*0.97*currency.rateSell).toFixed(2):(+form.amount*0.985*currency.rateSell).toFixed(2)}₴`}

                </div>
                <div className="textWithInfoHelp">
                    {t("choose_payment")} 
                    <div className="infoHelp">
                        <Hint align='left' item={hint[11]}/>
                    </div>
                </div>
                {checkReturn=='f' && <div className="prInput">
                    <Select
                        id="cashoutType"
                        value={form.cashoutType || ''}
                        onChange={changeHandlerForm}
                        placeholder="Нічого не обрано"
                        options={[
                            {id: '', title: t('empty_select')},
                            {id: 'card/p2p', title: 'Card CooCooPay p2p (UAH)'},
                            {id: 'card/qvazi', title: 'Card CooCooPay qvazi (UAH)'},
                            // {id: 'iban', title: 'IBAN'},
                        ]}
                    />
                </div>}
                {checkReturn=='c' && <div className="prInput">
                    <Select
                        id="cashoutType"
                        value={form.cashoutType || ''}
                        onChange={changeHandlerForm}
                        placeholder="Нічого не обрано"
                        options={[
                            {id: '', title: t('empty_select')},
                            {id: 'wallet', title: 'Криптовалютний гаманець'},
                            {id: 'iban', title: 'IBAN'},
                        ]}
                    />
                </div>}
                {checkReturn=='c' && form.cashoutType === 'wallet' && (
                    <div className="prInput" >
                        <label htmlFor="wallet" className="prInputLabel">{t("Адреса гаманця")}</label>
                        <input
                            type="text"
                            id="wallet"
                            className={errors.wallet ? "prInputInput inputError" : "prInputInput"}
                            value={form.wallet || ""}
                            onChange={changeHandlerForm}
                            onBlur={validationHandler}
                        />
                        {errors.wallet && <div className="error">{errors.wallet}</div>}
                    </div>
                )}

                {/* { checkReturn=='f' && form.cashoutType&&(
                    <div className="prInput" >
                        <label htmlFor="cardHolder" className="prInputLabel">
                            {form.cashoutType === 'card' ? (
                                t("Ім'я власника карти")
                            ) : (
                                t("Ім'я власника рахунку")
                            )}
                        </label>
                        <input
                            type="text"
                            id="cardHolder"
                            className={errors.cardHolder ? "prInputInput inputError" : "prInputInput"}
                            value={form.cardHolder || ""}
                            onChange={changeHandlerForm}
                            onBlur={validationHandler}
                        />
                        {errors.cardHolder && <div className="error">{errors.cardHolder}</div>}
                    </div>
                )} */}
                {(form.cashoutType === 'card' || form.cashoutType === 'card/p2p'||form.cashoutType === 'card/qvazi') && (
                    <div className="prInput" >
                        <label htmlFor="cardNumber" className="prInputLabel">{t("Номер картки")}</label>
                        <input
                            type="number"
                            id="cardNumber"
                            className={errors.cardNumber ? "prInputInput inputError" : "prInputInput"}
                            value={form.cardNumber || ""}
                            onChange={changeHandlerForm}
                            onBlur={validationHandler}
                        />
                        {errors.cardNumber && <div className="error">{errors.cardNumber}</div>}
                    </div>
                )}
                {form.cashoutType === 'iban' && (
                    <>
                        <div className="prInput" >
                            <label htmlFor="ibanNumber" className="prInputLabel">{t("Номер рахунку")}</label>
                            <input
                                type="text"
                                id="ibanNumber" 
                                className={errors.ibanNumber ? "prInputInput inputError" : "prInputInput"}
                                value={form.ibanNumber || ""}
                                onChange={changeHandlerForm}
                                onBlur={validationHandler}
                            />
                            {errors.ibanNumber && <div className="error">{errors.ibanNumber}</div>}
                        </div>
                        {checkReturn=='f' && <div className="prInput" >
                            <label htmlFor="taxId" className="prInputLabel">{t("РНОКПП/ЄДРПОУ")}</label>
                            <input
                                type="text"
                                id="taxId" 
                                className={errors.taxId ? "prInputInput inputError" : "prInputInput"}
                                value={form.taxId || ""}
                                onChange={changeHandlerForm}
                                onBlur={validationHandler}
                            />
                            {errors.taxId && <div className="error">{errors.taxId}</div>}
                        </div>}
                    </>
                )}
                <div className="dFlex jCC">
                    <button className="prButton prButtonMain" onClick={returnClick}>{t('return')}</button>
                </div>
            </div>}
           
        </div>



        <div className="profileSection">
            <div className="prFlexRow profileSectionHeader">
                <h2 >{t('my_transaction')}
                <div className="infoHelp">
                        <Hint align='left' item={hint[12]}/>
                    </div></h2>
                <div className="prFlexRow" style={{gap:'25px'}}>
                    <button className="prButton prButtonMainP prButtonSecond prFlexRow roomFilterButton" onClick={() => setIsOpen(true)}>
                        <Icon type="filter" /> {t("filter_show")}
                    </button>
                </div>
                {/* <a className="profileSectionHeaderLink link">{t('all_games')}<Icon type='rightarrow'/></a> */}
            </div>
            <div className="filterBlock">
                <div className="prFlexRow">
                    <div className="prFlexRow">
                        <div className="prFlexRow filterBlockFilter">
                            <div className="filterBlockSortText">{t("filter_period")}:</div>
                            <DatePicker id="dateFrom" value={(filter.dateFrom?.length>1 && getDate(filter.dateFrom,'dd/mm/yyyy','.')) || ''} onChange={changeHandler} onBlur={initFunc} icon={true} />
                            <div>-</div>
                            <DatePicker id="dateTo" value={(filter.dateTo?.length>1 && getDate(filter.dateTo,'dd/mm/yyyy','.')) || ''} onChange={changeHandler}  onBlur={initFunc} icon={true} />
                        </div>
                        <div className="filterBlockSort prFlexRow">
                            <div className="filterBlockSortText">{t("filter_sort")}:</div>
                            <Sort
                                sort={sort}
                                sortOptions={sortOptions}
                                sortOption={sortValue}
                                page="profileWalletPageSort"
                                onChange={onSortValueChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="filterBlockFilteredText">
                    {t("filter_find")} {transaction?.total} {t("filter_all")} {transaction?.totalFilter}
                </div>
            </div>
            <div className="roomList">
                {transaction?.list?.length>0 && transaction.list.map(el=>{
                    return(
                        <div className="roomItem prFlexRow userTransactionsBlock" >
                            <div className="roomItemTabletBlockHeader prFlexRow">
                                <div className="roomItemLink" >{el.id}</div>   
                                <div className="prFlexRow">
                                    <div className="roomItemBlockValue"><Icon type='time'></Icon>   {getDate(el.createdAt.replace('T',' '),'hh:mm',":")}</div>
                                    <div style={{marginLeft:'18px'}} className="roomItemBlockValue"><Icon type='calendar'></Icon> {getDate(el.createdAt.replace('T',' '),'dd/mm/yyyy',".")}</div>
                                </div>
                            </div>
                            <div className="roomItemMobileBlockHeader">
                                <div style={{ cursor: 'pointer' }} >
                                    <div className="roomItemBlockHeader">ID транзакції</div>
                                    <div className="roomItemLink" style={{cursor:'pointer'}} onClick={el.type=='0'?()=>{return}:el.currencyType=='0'?() => window.open('https://rivalsroom.pay.whitepay.com/crypto-orders/' + el.idTransaction,'_blank','noopener,noreferrer'):() => window.open('/api/v1/transaction/redirect/'+el.id+'?token='+token,'_blank', 'noopener')}>{el.id}</div>
                                </div>
                                <div className="roomItemMoney">
                                    <div className="roomItemMoneyValue prFlexRow">{el.quantity} {el.currencyType=='0'?<Icon type='cTocken'></Icon>:<Icon type='fTocken'></Icon>} </div>
                                </div>
                            </div>
                            <div className="" >
                                <div className="roomItemBlockHeader">{t('transaction_id')}</div>
                                <div className="roomItemLink" style={{ cursor: 'pointer' }} onClick={el.type=='0'?()=>{return}:el.currencyType=='0'?() => window.open('https://rivalsroom.pay.whitepay.com/crypto-orders/' + el.idTransaction,'_blank','noopener,noreferrer'):() => window.open('/api/v1/transaction/redirect/'+el.id+'?token='+token,'_blank', 'noopener')}>{el.id}</div>
                            </div>
                            <div className="roomItemBlock">
                                <div className="roomItemBlockHeader">{t('transaction_type')}</div>
                                <div className="roomItemBlockValue">{el.type=='0'?"Виведення":"Поповнення"}</div>
                            </div>
                            <div className="roomItemMoney roomItemFullBlock">
                                <div className="roomItemMoneyValue prFlexRow">{el.quantity} {el.currencyType=='0'?<Icon type='cTocken'></Icon>:<Icon type='fTocken'></Icon>}</div>
                            </div>
                            <div className="roomItemMobileBlock">
                                <div className="roomItemBlockHeader">{t('status')}</div>
                                <div className="roomItemBlockValue">{list[el.transactionStatus]}</div>
                            </div>
                            <div className="roomItemBlock">
                                <div className="roomItemBlockHeader">{t('payment_org')}</div>
                                <div className="roomItemBlockValue">{el.paymentSystem}</div>
                            </div>
                            <div className="roomItemBlock">
                                <div className="roomItemBlockHeader">{t('time_created')}</div>
                                <div className="prFlexRow dateTimeBlock"> 
                                        <div className="roomItemBlockValue"><Icon type='time'></Icon>   {el.createdAt?getDate(el.createdAt,'hh:mm',":"):'--:--'}</div>
                                        <div style={{marginLeft:'18px'}} className="roomItemBlockValue"><Icon type='calendar'></Icon> {el.createdAt?getDate(el.createdAt,'dd/mm/yyyy',"."):'--.--.----'}</div>
                                    </div>
                            </div>
                        </div>
                    )}
                )}
            </div>
            {transaction?.total>10&&<Pagination
                className="pagination-bar"
                currentPage={pageCur}
                totalCount={transaction.total}
                pageSize={10}
                onPageChange={(page) => {
                    setPageCur(page);
                    initFunc(page);
                }}
            />}
        </div>
        {isOpen && <Filter type='transaction' resetFilter={resetFilter} accept={applyFilter} filter={filter} setFilter={setFilter} onChange={changeHandler} isOpen={isOpen} setIsOpen={setIsOpen} />}
    </>)

}

export default ProfileWalletPage;